import React from "react";

import { PeopleCard, PeopleList } from "@caelor/ui";

import { OVERVIEW_DUMMY_DATA } from "./data";
import {
  PeopleCardOverviewContainer,
  PeopleContainer,
  PeopleOverviewContainer,
  PeopleTitle,
  PeopleWrapper,
  SubtitleContainer,
} from "./styles";
import { useOpticsStore } from "../../../../../../stores/use-optics-store";
import { MACRO_KEY } from "../../../../../defaults";
import { useRecentlyActiveStore } from "../../../../../../stores/use-recently-active-store";
import { useStyleguideColors } from "../../../../../../hooks/use-styleguide-colors";
import { DEFAULT_ACCENT_COLOR } from "../../../../../../features/people/defaults";
import {
  buildTemplate,
  RECENTLY_ACTIVE_TEMPLATES,
} from "./recently-active-templates";

const Subtitle = ({ type, variant, accentColor }) => (
  <SubtitleContainer>
    <span>{type} a&nbsp;</span>
    <p style={{ color: accentColor }}>{variant}</p>
  </SubtitleContainer>
);

const CardRender = ({ accent, borderRadius }) => (
  <div style={{ display: "flex", flexFlow: "row", gap: 8 }}>
    <div style={{ width: 166 }}>
      <PeopleCard
        name="Ava Turner"
        avatarUrl="/img/peopleList.svg"
        subtitle={
          <Subtitle type="Updated" variant="page" accentColor={accent} />
        }
        label="Design"
        accentColor={accent}
        borderRadius={borderRadius}
        isTemplate
      />
    </div>
    <div style={{ width: 166 }}>
      <PeopleCard
        name="Liam Brooks"
        avatarUrl="/img/peopleCard.svg"
        subtitle={
          <Subtitle type="Created" variant="space" accentColor={accent} />
        }
        label="Development"
        accentColor={accent}
        borderRadius={borderRadius}
        isTemplate
      />
    </div>
  </div>
);

const ListRender = ({ accent, borderRadius }) => (
  <div style={{ display: "flex", flexFlow: "column", gap: 8 }}>
    <div style={{ width: 475 }}>
      <PeopleList
        name="Angelica Lorens"
        avatarUrl="/img/peopleList.svg"
        subtitle={
          <Subtitle type="Updated" variant="page" accentColor={accent} />
        }
        label="Design"
        accentColor={accent}
        borderRadius={borderRadius}
        isTemplate
      />
    </div>
    <div style={{ width: 475 }}>
      <PeopleList
        name="Liam Brooks"
        avatarUrl="/img/peopleCard.svg"
        subtitle={
          <Subtitle type="Created" variant="space" accentColor={accent} />
        }
        label="Design"
        accentColor={accent}
        borderRadius={borderRadius}
        isTemplate
      />
    </div>
    <div style={{ width: 475 }}>
      <PeopleList
        name="Ava Turner"
        avatarUrl="/img/peopleList.svg"
        subtitle={
          <Subtitle type="Updated" variant="page" accentColor={accent} />
        }
        label="Design"
        accentColor={accent}
        borderRadius={borderRadius}
        isTemplate
      />
    </div>
  </div>
);

const VIEWS = {
  card: { label: "Card", View: CardRender },
  list: { label: "List", View: ListRender },
};

export const OverviewTemplates = () => {
  const { setData } = useRecentlyActiveStore((state) => ({
    setData: state.setData,
  }));
  const { setMacro, setDrawers, colorPalette, styleguideSetup } =
    useOpticsStore((state) => ({
      setMacro: state.setMacro,
      setDrawers: state.setDrawers,
      colorPalette: state.colorPalette,
      styleguideSetup: state.styleguideSetup,
    }));

  const borderRadius = styleguideSetup?.cornerRadius || 3;

  return (
    <PeopleOverviewContainer
      onClick={() => {
        setMacro({ key: MACRO_KEY.RECENTLY_ACTIVE });
        setData({ ...buildTemplate("card", borderRadius) });
        setDrawers({ templates: false, settings: true });
      }}
    >
      {OVERVIEW_DUMMY_DATA.map((person) => (
        <PeopleCardOverviewContainer>
          <PeopleCard
            name={person.name}
            avatarUrl={person.avatarUrl}
            subtitle={person.subtitle}
            label={person.label}
            accentColor={colorPalette?.accent}
            borderRadius={borderRadius}
          />
        </PeopleCardOverviewContainer>
      ))}
    </PeopleOverviewContainer>
  );
};

const RecentlyActiveTemplates = () => {
  const { setData, data } = useRecentlyActiveStore((state) => ({
    setData: state.setData,
    data: state.data,
  }));
  const { setDrawers, styleguideSetup } = useOpticsStore((state) => ({
    setDrawers: state.setDrawers,
    styleguideSetup: state.styleguideSetup,
  }));

  const styleguideColors = useStyleguideColors({
    styleguideSetup,
  });

  const color =
    data?.accentColor || styleguideColors?.accent || DEFAULT_ACCENT_COLOR;

  const borderRadius = data?.borderRadius || styleguideSetup?.cornerRadius || 3;

  const buildData = (template, value) => {
    if (Object.keys(data || {}).length) {
      return {
        ...data,
        view: value.view,
      };
    }

    return {
      ...template,
      ...value,
    };
  };

  return (
    <PeopleContainer>
      {RECENTLY_ACTIVE_TEMPLATES.map((template) => {
        const { label, View } = VIEWS[template.view];
        return (
          <PeopleWrapper
            key={template.id}
            onClick={() => {
              setData({
                ...buildData(template, {
                  accentColor: color,
                  borderRadius,
                  view: template.view,
                }),
              });
              setDrawers({ templates: false, settings: true });
            }}
          >
            <PeopleTitle>{label}</PeopleTitle>
            <View accent={color} borderRadius={borderRadius} />
          </PeopleWrapper>
        );
      })}
    </PeopleContainer>
  );
};

export default RecentlyActiveTemplates;
